<template>
  <vs-card>
    <div slot="header">
      <h3>Análise de Boletos</h3>
    </div>
    <div class="boletos" v-for="(boleto, index) of listBoletos" :key="index">
      <vs-chip class="mr-4" color="dark">{{ boleto.placa }} </vs-chip>
      <vs-chip class="mr-4" :color="getStatusBoletoColor(boleto.situacao)">
        {{ boleto.situacao }}
      </vs-chip>
      <vs-chip v-if="boleto.status" class="mr-4" color="danger">
        Vencido
      </vs-chip>
      <span>{{ boleto.mes_referente }}</span>
      <span>{{ boleto.data_vencimento }}</span>
      <span>{{ boleto.tipoBoleto }}</span>
    </div>
  </vs-card>
</template>

<script>
export default {
  props: ['listBoletos'],
  methods: {
    getStatusBoletoColor(data) {
      if (data == 'BAIXADO') return 'success';
      if (data == 'ABERTO') return 'warning';
      return 'danger';
    },
  },
};
</script>

<style lang="scss" scoped>
.boletos {
  margin-bottom: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 8px;
  display: flex;
  align-items: center;

  span {
    margin-right: 8px;
    font-size: 1.2rem;
  }
}
</style>
